import React from 'react';
import Axios from 'axios';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { API_HOST } from '../../consts';
import TableGeneralStudentReport from '../relatorio/TableGeneralStudentReport';
import HeaderRelatorioTurma from '../../components/HeaderRelatorioTurma';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import { Grid } from '@material-ui/core';
import { Form } from 'informed';
import { withTheme } from 'styled-components';
import InputSelect from '../../components/inputs/InputSelect';
import { GeneralStudentStyleButton } from './style';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';


class GeneralStudentSkillReport extends React.Component {
  state = {
    habilidadeData: [],
    fetchingData: true,
    relatorioTurma: []
  };
  host = window.location.host;

  handleFilterChange = (filters) => {
    this.props.onFilterChange(filters);
  };

  Accordion = withStyles({
    root: {
      boxShadow: 'none',
      '&:not(:last-child)': {
        borderBottom: 0
      },
      '&:before': {
        display: 'none'
      },
      '&$expanded': {
        marginTop: '10px',
        marginBottom: '10px',
        margin: 'auto'
      }
    },
    expanded: {}
  })(MuiAccordion);

  AccordionSummary = withStyles({
    root: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: this.props.theme.primary,
      border: 'none',
      borderRadius: '16px',
      height: '42px',
      boxShadow: '0px 0px 4.94866px rgba(0, 0, 0, 0.25)',
      marginBottom: '10px',
      '&$expanded': {
        minHeight: 56
      }
    },
    content: {
      '&$expanded': {
        margin: '12px 0'
      }
    },
    expanded: {}
  })(MuiAccordionSummary);

  AccordionDetails = withStyles((theme) => ({
    root: {
      width: '100%',
      backgroundColor: '#FFFFFF',
      padding: theme.spacing(2),
      border: '1px solid #F7F7F7',
      borderRadius: '8px'
    }
  }))(MuiAccordionDetails);

  componentDidMount() {
    this.fetchrelatorioTurma();
    this.fetchHabilidade();
  }

  fetchrelatorioTurma = () => {
    const {filtrosRelatorios} = this.context;
    Axios.get(
      `${API_HOST}/avalia/boletim_mt?CD_ESCOLA=${filtrosRelatorios.currentEscola}&CD_TURMA=${filtrosRelatorios.cd_turma}&CD_DISCIPLINA=${filtrosRelatorios.DisciplinaID}&PERIODO_ANO_ID__id=${filtrosRelatorios.periodoAno}&NR_ETAPA=${filtrosRelatorios.nrEtapa}`
    )
      .then((res) => {
        this.setState({
          relatorioTurma: res.data.results
        });
      })
      .catch((err) =>
        toast.error('Não existem dados para a consulta realizada')
      );
  };

  fetchHabilidade = (param) => {
    const {filtrosRelatorios} = this.context;
    const params = {
      tipo: 'aluno-hab-turma',
      nr_etapa: filtrosRelatorios.nrEtapa,
      cd_turma: filtrosRelatorios.cd_turma,
      disciplina_id: filtrosRelatorios.DisciplinaID,
      cd_habilidade: get(param, 'value')
    };

    Axios.get(
      `${API_HOST}/avalia/estudante_desempenho/get_complex_data_student_class_table`,
      {
        params
      }
    )
      .then((res) => {
        this.setState({
          habilidadeData: res.data,
          fetchingData: false
        });
      })
      .catch((err) => console.error(err));
  };

  columnsHabilidade = [
    {
      id: 'habilidade',
      editable: true,
      label: 'Habilidade',
      minWidth: 170,
      align: 'center'
    },
    { id: 'nm_aluno', label: 'Estudante', minWidth: 170, align: 'center' },
    { id: 'status', label: 'Status', minWidth: 170, align: 'center' },
    {
      id: 'idn',
      label: 'Relatório individual',
      minWidth: 100,
      align: 'center'
    }
  ];

  render() {
    const { filtrosRelatorios, setStateFilters } = this.context;
    let uniqueDataHabilidadeId = [];
    let uniqueDataHabilidade = [];
    const { habilidadeData, relatorioTurma } = this.state;

    habilidadeData.map((data) => {
      if (
        uniqueDataHabilidadeId.indexOf(data.cd_habilidade) === -1 &&
        uniqueDataHabilidade.indexOf(data.habilidade) === -1
      ) {
        uniqueDataHabilidadeId.push(data.cd_habilidade);
        uniqueDataHabilidade.push({
          value: data.cd_habilidade,
          label: data.habilidade
        });
      }
    });
    return (
      <>
        <div
          className="card-header"
          style={{
            marginBottom: '-0.7rem',
            backgroundColor: '#f7f7f7',
            borderRadius: '10px'
          }}
        >
          <h1
            style={{
              fontFamily: 'Quicksand',
              fontSize: '24px',
              color: '#292929',
              fontWeight: 'bold'
            }}
          >
            Relatório de Estudantes por habilidade
          </h1>
          <hr
            style={{
              background: '#bebebe',
              width: '100%',
              height: '1px',
              borderRadius: '1px'
            }}
          />
        </div>
        <div
          className="input-type-style"
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginLeft: '4rem'
          }}
        >

          <Form
            onChange={(formState) => this.setState({ formState })}
            onValueChange={this.onValueChange}
            getApi={(formApi) => {
              this.formApi = formApi;
            }}
            style={{width:'100%'}}
          >
            <this.Accordion
              defaultExpanded
              style={{ marginTop: '1rem', width: '100%' }}
            >
              <this.AccordionSummary
                expandIcon={
                  <ArrowDropDownIcon
                    style={{
                      fontSize: '2.5rem',
                      color: '#FFFFFF'
                    }}
                  />
                }
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <label
                    style={{
                      color: '#FFFFFF',
                      fontFamily: 'Quicksand',
                      fontWeight: '700',
                      fontSize: '19px',
                      marginBottom: '2px',
                      marginRight: '5px'
                    }}
                  >
                    Comparação de Estudantes por habilidade
                  </label>
                  <HelpOutlinedIcon
                    style={{
                      fontSize: '19px',
                      color: this.props.theme.secondary
                    }}
                  />
                </div>
              </this.AccordionSummary>
              <this.AccordionDetails>
                <Grid item container xs={12} md={12}>
                  <Grid
                    item
                    xs={9}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      zIndex: '100'
                    }}
                  >
                    <InputSelect
                      label="Habilidade"
                      col="col-md-12"
                      field="cd_habilidade"
                      onChange={this.fetchHabilidade}
                      options={uniqueDataHabilidade}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <h1> Habilidade </h1>
                    <TableGeneralStudentReport
                      columns={this.columnsHabilidade}
                      rows={habilidadeData}
                      pagination={true}
                      periodoId={filtrosRelatorios.periodoAno}
                    />
                  </Grid>
                </Grid>
              </this.AccordionDetails>
            </this.Accordion>
          </Form>

        </div>


      </>
    );
  }
}
GeneralStudentSkillReport.contextType = FilterRelatorioContext;
export default withTheme(GeneralStudentSkillReport);
